import React, { useMemo, useState } from 'react'
import { Divider, Menu, MenuItem } from '@material-ui/core'
import PropTypes from 'prop-types'
import Icon from '../../../../../components/atoms/Icon'
import PersonalSpace from '../../../../../components/molecules/PersonalSpace'
import SummitOnlyContent from '../../../../../components/atoms/SummitOnlyContent'

export const useScheduleMenu = (onRename, onCopy, onDelete) => {
  const [menuAnchor, setMenuAnchor] = useState(null)

  return useMemo(() => {
    const handleMenuOpen = (event) => {
      event.preventDefault()
      event.stopPropagation()
      setMenuAnchor(event.currentTarget)
    }

    const handleMenuClose = (e) => {
      e.preventDefault()
      e.stopPropagation()
      setMenuAnchor(null)
    }

    const handleEdit = (result) => (e) => {
      onRename?.(result)
      handleMenuClose(e)
    }

    const handleCopy = (result) => (e) => {
      onCopy?.(result)
      handleMenuClose(e)
    }

    const handleDelete = (result) => (e) => {
      onDelete?.(result)
      handleMenuClose(e)
    }
    return {
      menuAnchor,
      setMenuAnchor,
      handleEdit,
      handleCopy,
      handleDelete,
      handleMenuOpen,
      handleMenuClose
    }
  }, [onRename, onCopy, onDelete, menuAnchor, setMenuAnchor])
}

function ScheduleMenu ({ subject, menuAnchor, onClose, onEdit, onCopy, onDelete, className }) {
  return (
    <Menu
      className={className}
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={onClose}
    >
      <MenuItem onClick={onEdit(subject)}>
        <Icon name='edit' style={{ marginRight: '8px', fontSize: '16px' }} />
        Edit
      </MenuItem>
      <SummitOnlyContent>
        <MenuItem onClick={onCopy(subject)}>
          <Icon name='copy' style={{ marginRight: '8px', fontSize: '16px' }} />
          Copy To User
        </MenuItem>
      </SummitOnlyContent>
      <PersonalSpace size={10} />
      <Divider />
      <MenuItem onClick={onDelete(subject)} style={{ color: 'var(--color-danger-500)' }}>
        <Icon name='delete' style={{ marginRight: '8px', fontSize: '16px' }} />
        Delete
      </MenuItem>
    </Menu>
  )
}

ScheduleMenu.propTypes = {
  subject: PropTypes.shape({
    scheduleId: PropTypes.string,
    name: PropTypes.string
  }),
  menuAnchor: PropTypes.any,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  onCopy: PropTypes.func,
  onDelete: PropTypes.func,
  className: PropTypes.string
}

export default ScheduleMenu
